'use strict';

var globalHeaderComponent = {
  templateUrl: 'templates/partials/global/header.tpl.html',
  bindings: {
    onLogOut: '&',
  },
  controller: /*@ngInject*/ function (
    $scope,
    Session,
    KeymageService,
    ReactNavigationService
  ) {
    var _self = this;

    _self.setKeyBindings = function () {
      KeymageService.set($scope, [
        {
          shortcut: 'ctrl-s',
          fn: function () {
            ReactNavigationService.goToSearch();
          },
        },
      ]);
    };

    _self.setUserData = function () {
      _self.user = {
        name: Session.get('name'),
      };
    };

    _self.$onInit = function () {
      _self.setUserData();
      _self.setKeyBindings();
    };

    _self.showLogoutModal = function () {
      _self.onLogOut();
    };
  },
};

module.exports = globalHeaderComponent;
